import { TranslocoService } from '@jsverse/transloco';
import { DropdownOption } from 'htx-ui-library';

export const SALUTATION_VALUES = ['', 'prof', 'prof_dr', 'dr', 'dr_med', 'dr_jur', 'dr_ing', 'mag', 'dipl', 'dipl_ing'] as const;

export function buildSalutationOptions(translocoService: TranslocoService): DropdownOption[] {
  return SALUTATION_VALUES.map((value) => ({
    value,
    label: value
      ? translocoService.translate(`registration.page.userForm.controls.salutation.options.${value}`)
      : '',
  }));
}
